import { render } from "./CardEmail.vue?vue&type=template&id=015122df"
import script from "./CardEmail.vue?vue&type=script&lang=js"
export * from "./CardEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__